/**
 * A simple RXjs stream which holds the current logged-in user.
 * This is intentionally not part of `CurrentUser.model.js` so that the redux state doesn't need
 * to be loaded to use it.
 *
 * @example
 *  import CurrentUserStream from 'modules/user/CurrentUserStream';
 *
 *  CurrentUserStream.subscribe((user) => {
 *    console.log('The user is now:', user);
 *  });
 *
 */

import { isEqual } from 'underscore';
import { subscribe } from 'redux-subscriber';
import Rx from 'rx';
import createDefaultUser from './createDefaultUser';

// Ensure there is only one stream.
const CurrentUserStream = new Rx.BehaviorSubject(createDefaultUser());

export default CurrentUserStream;

let currentUser;

export const onNextUser = nextUser => {
  // Don't update if the user object hasn't changed
  if (isEqual(currentUser, nextUser)) {
    return;
  }
  // Keep a reference to the current user
  currentUser = nextUser;
  CurrentUserStream.onNext(nextUser);
};

// Update stream when user object state changes
subscribe('user', state => {
  onNextUser(state.user || createDefaultUser());
});
